//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';

import { deserializeRightsPermissions } from '@apis/rights-management/rightsManagementApiUtils';
import Cuid from '@models/Cuid';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { Serialized } from '@utils/types/Serialized';

export const deserializeMediaItem = (
  item: Serialized<IMlsMediaItem>,
): IMlsMediaItem => ({
  ...item,
  rightsPermissions: deserializeRightsPermissions(item.rightsPermissions),
  networkItem: item.networkItem && {
    ...item.networkItem,
    observationTime: new Date(item.networkItem.observationTime),
    postedTime: new Date(item.networkItem.postedTime),
  },
});

export const deserializeMediaItems = (
  mediaItems: Serialized<PojoMap<Cuid, IMlsMediaItem>>,
): PojoMap<Cuid, IMlsMediaItem> => {
  return PojoMap.map(mediaItems, (item) => deserializeMediaItem(item));
};
